




























import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class DialogSkipUpload extends Vue {

    @Prop(Boolean) show!: boolean
    @Prop(String) title!: string

    reason: string = ''
    whynot: Array <any> = [
      'Not part of the Client\'s specification',
      'Not required by Client, email or verbal communication',
      'Operator Error',
      'Equipment failure',
      'Previously Uploaded'
    ]
    setReason() {
      if( this.reason ) {
        this.$emit('skip-upload', this.title, this.reason);
      }
    }
}
